export default __webpack_public_path__ + "static/media/landing-image.d0147f08.svg";